export const zhCN_globalTips = {
  'gloabal.tips.notfound': '对不起，您访问的页面不存在。',
  'gloabal.tips.unauthorized': '对不起，您没有权限访问此页。',
  'gloabal.tips.loginResult': '看到此页面代表您已登录。',
  'gloabal.tips.goToLogin': '去登录',
  'gloabal.tips.login': '登录',
  'gloabal.tips.username': '用户名',
  'gloabal.tips.enterUsernameMessage': '请输入用户名！',
  'gloabal.tips.password': '密码',
  'gloabal.tips.enterPasswordMessage': '请输入密码！',
  'gloabal.tips.rememberUser': '记住用户',
  'gloabal.tips.backHome': '返回首页',
  'gloabal.tips.operation': '操作',
  'gloabal.tips.authorize': '授权',
  'gloabal.tips.delete': '删除',
  'gloabal.tips.create': '新建',
  'gloabal.tips.modify': '修改',
  'gloabal.tips.search': '搜索',
  'gloabal.tips.reset': '重置',
  'gloabal.tips.deleteConfirm': '确定要删除此条数据吗？',
  'gloabal.tips.loading': '加载中...',
  'gloabal.tips.theme.darkTooltip': '切换至深色主题',
  'gloabal.tips.theme.lightTooltip': '切换至浅色主题',
  'gloabal.tips.theme.noticeTooltip': '通知',
};
